/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CustomerDepartmentService,
  type Wealthlane_CustomerService_Dtos_CustomerDepartment_UpdateCustomerDepartmentDto,
  type Wealthlane_CustomerService_Dtos_CustomerDepartment_CustomerDepartmentDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import {
  GrantAcceptanceTemplateService,
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePostGrantAcceptanceTemplateNameAndStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      //   if (id != null && id !== '') {
      return await handleRequest(
        GrantAcceptanceTemplateService.putApiAwardApiAppGrantAcceptanceTemplateTemplate(payload)
      );
      //   }
    },
    {
      onSuccess: async (
        response: Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getGrantAcceptanceTemplateList');
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Grant Acceptance Template Name and Status edited.`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostGrantAcceptanceTemplateNameAndStatus;
